// extracted by mini-css-extract-plugin
module.exports = {"errorMsg":"WordCloud2d__errorMsg__GKc08","chartBox":"WordCloud2d__chartBox__tqc9l","chartDom":"WordCloud2d__chartDom__S70lH"};